// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuProvider_container__G1O9s","innerContainer":"MenuProvider_innerContainer__nAnSj"};